import { createAction } from 'redux-actions';

export const appLoaded = createAction('APP_LOADED');
